import { customAlphabet } from 'nanoid';

export function generateId() {
  const nanoid = customAlphabet('123456789bcdfghkmnpstwx');
  return nanoid(8);
}

export function generateNumericId(len) {
  const nanoid = customAlphabet('1234567890');
  return nanoid(len);
}

// Generate a short unique ID for citations
export function generateUniqueId(len) {
  // Create a string of possible characters (excluding similar-looking characters)
  // const chars = '23456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz';
  // all lowercase
  const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
  let id = '';

  // Generate a len-character ID
  for (let i = 0; i < len; i++) {
    id += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return id;
}

const LABELS_SHORT = {
  motif: 'mf',
  pattern: 'pn',
  project: 'pr',
  yarn: 'yn',
  colorway: 'cw',
  layout: 'ly',
  part: 'pt',
  note: 'nt',
  step: 'sp',
  stitch: 'st'
};

export const generateEntityId = (label) => {
  if (!Object.keys(LABELS_SHORT).includes(label)) {
    throw new Error(`Invalid entity label: ${label}`);
  }
  return `${LABELS_SHORT[label]}_${generateUniqueId(8)}`;
};

export function _getItemId(item) {
  return `${item.label}/${item.pk}/${item.id}`;
}

export const crafts = [
  'knitting',
  'crochet'
  //"origami",
  //"cooking",
  //"music",
  //"art"
];

export function isArrayOfStrings(obj) {
  if (!Array.isArray(obj)) {
    return false;
  }
  for (let i = 0; i < obj.length; i++) {
    if (typeof obj[i] !== 'string') {
      return false;
    }
  }
  return true;
}

// ISO 8601 UTC standard yyyy-MM-ddTHH:mm:ss.fffffffZ
export function getCosmosDate() {
  return new Date(Date.now()).toISOString();
}

export function formatDate(date) {
  const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
  return date ? new Date(date).toLocaleDateString('en-US', options) : '';
}

export function formatDateTime(date) {
  const options = {
    weekday: 'short',
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  };
  return date ? new Date(date).toLocaleTimeString('en-US', options) : '';
}

export function formatDateShort(date) {
  const options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  return date ? new Date(date).toLocaleDateString('en-US', options) : '';
}

export function getMonthYear(d) {
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
}

export function _tsToDateTime(_ts) {
  return new Date(_ts * 1000).toLocaleString();
}

export const isToday = (date) => {
  const today = new Date();
  const checkDate = new Date(date);
  return checkDate.toDateString() === today.toDateString();
};

export const getTimeShort = (date) => {
  return new Date(date).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
};

export const getDayMonth = (date) => {
  return new Date(date).toLocaleDateString([], { month: 'short', day: 'numeric' });
};

/**
 * Converts an object to an array of objects with 'id' property
 * @param {Object} obj - The object to convert
 * @returns {Array} Array of objects with 'id' property
 * @example
 * const obj = { a: { name: 'A' } };
 * objectToArray(obj); // [{ id: 'a', name: 'A' }]
 */
export const objectToArray = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return [];
  }
  return Object.entries(obj).map(([key, value]) => ({
    id: key,
    ...value
  }));
};
